import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { apiUrls } from "../../constants/apiUrls";

export const getCartDetails = async (data) => {
  const apiPayload = {
    method: "GET",
    data,
    url: Env.getLcoBasePath() + apiUrls.getCartDetails,
    useParentKey: true
  };

  return handlePromise(apiPayload);
};

export const getProductList = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getLcoBasePath() + apiUrls.getProductList
  };

  return handlePromise(apiPayload);
};

export const getProductDetail = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getLcoBasePath() + apiUrls.getProductDetail
  };

  return handlePromise(apiPayload);
};

export const submitOrderDetails = async (data) => {
  const apiPayload = {
    method: "POST",
    data,
    url: Env.getLcoBasePath() + apiUrls.submitOrderDetails
  };

  return handlePromise(apiPayload);
};

export const getPaymentTerms = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getLcoBasePath() + apiUrls.getPaymentTerms
  };

  return handlePromise(apiPayload);
};





